// extracted by mini-css-extract-plugin
module.exports = {"root":"FileCreatedBy_root___eJPD","name":"FileCreatedBy_name__C8LCd"};